/* global __APP_CONFIG__, __webpack_public_path__:writable */
const appConfig = typeof __APP_CONFIG__ !== 'undefined' ? __APP_CONFIG__ : {};

if (appConfig.VUE_APP_WEBPACK_PUBLIC_PATH) {
  __webpack_public_path__ = appConfig.VUE_APP_WEBPACK_PUBLIC_PATH;
} else if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
  __webpack_public_path__ = "http://localhost:8081/"
}
import Vue from 'vue'
import Notifications from 'vue-notification'
import VTooltip from 'v-tooltip'

import 'bootstrap/scss/_spinners.scss';
import 'bootstrap/dist/css/bootstrap-utilities.min.css';

import store from './store'
import router from './router'
import i18n from './i18n'
import App from './App'
import axiosConfig from './config/axios';

// import VueResource from 'vue-resource'
import clickOutsideDirective from "./directives/click-outside";

// detects clicks outside the element
clickOutsideDirective;

Vue.use(Notifications);
// Vue.use(VueResource);
Vue.use(VTooltip, {
  defaultContainer: '.app.bodhi-vue-app',
  defaultBoundariesElement: 'window'
});

// Function to load and initialize Pendo, adapted from them to be in a promise / async
async function loadAndInitializePendo(apiKey, visitorData) {
  try {
    const pendo = await new Promise((resolve, reject) => {
      (function (apiKey_1) {
        (function (p, e, n, d, o) {
          let v, w, x, y, z;
          o = p[d] = p[d] || {};
          o._q = o._q || [];
          v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
          for (w = 0, x = v.length; w < x; ++w) (function (m) {
            o[m] = o[m] || function () {
              o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
            };
          })(v[w]);
          y = e.createElement(n);
          y.async = true;
          y.onload = () => resolve(window?.pendo);
          y.onerror = reject;
          y.src = 'https://cdn.eu.pendo.io/agent/static/' + apiKey_1 + '/pendo.js';
          z = e.getElementsByTagName(n)[0];
          z.parentNode.insertBefore(y, z);
        })(window, document, 'script', 'pendo');
      })(apiKey);
    });
    if (pendo) {
      pendo.initialize(visitorData);
    } else {
      console.error('Pendo is not available on the window object.');
    }
  } catch (error) {
    console.error('Failed to load Pendo script:', error);
  }
}

//right now this showcases mainly the implementation of a filter dropdown component
// it has some extra helpers that we used when we were working on the bodhi migration , as they might be helpful in the future
document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    store,
    router,
    i18n,
    render: h => h(App)
  }).$mount('#app')
  const apiKey = appConfig.VUE_APP_PENDO_API_KEY;
  if (apiKey) {
    let environment = (location.hostname === 'localhost' || location.hostname === '127.0.0.1') ? 'development' : appConfig.environment;
    const userData = JSON.parse(localStorage.getItem('projectcode-user'));
    let pendoPayload;
    if (userData?.id) {
      pendoPayload = {
        visitor: {
          id: `b-${userData.id}`,
          email: `${userData?.email || 'N/A'}`,
          full_name: `${userData?.full_name || 'N/A'}`,
          environment: environment,
          sub_system: 'bodhi-vue'
        },
        account: {
          id: 'b-1', // we hard code this, its the same as org id = 1, but it must not clash with the insights one
          name: 'CARMA (Bodhi)',
          is_bodhi: true, // agent in pendo settings
          environment: environment, // agent in pendo settings
          sub_system: 'bodhi-vue'
        }
      };
    }
  if (apiKey && pendoPayload) {
    loadAndInitializePendo(apiKey, pendoPayload).then(() => {
      console.debug(`Bodhi-VUE: Pendo Initialized for user - ${userData.id} on ${environment}`);
      // Track route changes
      router.beforeEach((to, from, next) => {
        if (window?.pendo) {
          window.pendo.pageLoad();
        }
        next();
      });
    });
  }
  } else {
    console.error('Missing `VUE_APP_PENDO_API_KEY` in config, Pendo not initialized');
  }
});